import { defaultHttpClient } from '../../httpClient';
import type { GetRelatedOutfitListResponse } from './types';

export const getRelatedOutfits = (sno: number) => {
  return defaultHttpClient
    .request<GetRelatedOutfitListResponse>({
      method: 'GET',
      url: `/api/v2/goods/${sno}/related-outfits`,
    })
    .then(result => result.data);
};
